import React from "react";
import Logo from "./Logo";

const TermsPage = () => (
  <div className="min-h-screen bg-slate-950 text-slate-100 font-sans">
    <header className="fixed w-full z-50 bg-slate-950/95 backdrop-blur-md shadow-lg border-b border-slate-800 py-3">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 flex items-center justify-between">
        <a href="/" className="flex items-center hover:opacity-80 transition-opacity">
          <Logo />
        </a>
        <a
          href="/privacy"
          className="text-sm text-sky-400 hover:text-sky-300 transition-colors border border-sky-500/40 rounded-lg px-3 py-1.5"
        >
          Privacy Policy
        </a>
      </div>
    </header>

    <main className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8 pt-32 pb-10 space-y-10">
      <div>
        <p className="text-sky-400 uppercase text-xs font-semibold tracking-widest mb-3">Terms of Use</p>
        <h1 className="text-4xl font-bold text-white mb-4">CloudMortgage.io Terms of Use</h1>
        <p className="text-slate-400">
          These Terms govern access to and use of CloudMortgage.io by lenders, their teams, and invited borrowers.
          By accessing or using the platform, you agree to these Terms. If you do not agree, do not use the service.
        </p>
      </div>

      <section className="space-y-3">
        <h2 className="text-2xl font-bold text-white">No legal, credit, or lending advice</h2>
        <p className="text-slate-400">
          CloudMortgage.io provides workflow tools, document handling, and AI-assisted summaries. It does not provide
          legal, credit, tax, or investment advice and does not issue credit decisions. Lenders remain solely
          responsible for compliance, credit determinations, and all borrower communications.
        </p>
      </section>

      <section className="space-y-3">
        <h2 className="text-2xl font-bold text-white">Your responsibilities</h2>
        <ul className="list-disc list-inside text-slate-400 space-y-2">
          <li>Maintain accurate borrower and loan data and verify all calculations and summaries before use.</li>
          <li>Comply with all applicable laws, investor/agency rules, and internal underwriting policies.</li>
          <li>Manage user access, credentials, and permissions for your organization and invited borrowers.</li>
          <li>Obtain all required borrower consents for document sharing and third-party system connections.</li>
        </ul>
      </section>

      <section className="space-y-3">
        <h2 className="text-2xl font-bold text-white">Data accuracy and third parties</h2>
        <p className="text-slate-400">
          AI outputs, summaries, and calculations may contain errors. Always review and verify results before relying on
          them. Third-party services (e.g., Google Drive, cloud storage, LOS/CRM integrations) are subject to their own
          terms and availability; CloudMortgage.io is not liable for third-party outages or changes.
        </p>
      </section>

      <section className="space-y-3">
        <h2 className="text-2xl font-bold text-white">Acceptable use</h2>
        <p className="text-slate-400">
          Do not upload unlawful content, malware, or materials you lack rights to share. Do not attempt to disrupt or
          circumvent security. CloudMortgage.io may suspend or terminate access for violations or risk to the platform.
        </p>
      </section>

      <section className="space-y-3">
        <h2 className="text-2xl font-bold text-white">Disclaimers and limitation of liability</h2>
        <p className="text-slate-400">
          The service is provided “as is” and “as available” without warranties of any kind. To the maximum extent
          permitted by law, CloudMortgage.io disclaims all implied warranties and is not liable for indirect, incidental,
          consequential, or punitive damages, or for lost profits, revenue, or data. Direct damages, if any, are limited
          to fees paid for the service in the three months preceding the claim.
        </p>
      </section>

      <section className="space-y-3">
        <h2 className="text-2xl font-bold text-white">Confidentiality and security</h2>
        <p className="text-slate-400">
          We apply administrative, technical, and physical safeguards for customer data. You are responsible for
          protecting your credentials and the confidentiality of borrower information shared with your users.
        </p>
      </section>

      <section className="space-y-3">
        <h2 className="text-2xl font-bold text-white">Changes to the service and terms</h2>
        <p className="text-slate-400">
          We may update the platform or these Terms from time to time. Material changes will be communicated by posting
          an updated version. Continued use after changes constitutes acceptance.
        </p>
      </section>

      <section className="space-y-3">
        <h2 className="text-2xl font-bold text-white">Contact</h2>
        <p className="text-slate-400">Questions? Contact support@cloudmortgage.io.</p>
      </section>

      <div className="pt-6">
        <a
          href="/"
          className="inline-flex items-center justify-center px-5 py-3 rounded-lg bg-sky-600 text-white font-semibold hover:bg-sky-500 transition-colors"
        >
          Return to Home
        </a>
      </div>
    </main>
  </div>
);

export default TermsPage;
